<template>
  <div class='ProdutoView'>
    <div class="cont-item">
      <div class="block-left">
        <div class="cont-imgs">
        <div class="sold-out" v-if="ItemSelected01.gerEstoque && ItemSelected01.estoque <= 0 && ItemSelected01.tipo !== 'Variável'">Esgotado</div>
        <carousel
        :items-to-show="1"
        v-if="ItemSelected01.img.length"
        v-model="currentSlide"
        >
          <slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
            <div class="c-img">
            <vue-image-zoomer
            :regular="img"
            hover-message="⚲ Zoom"
            :img-width="computedSizeImg"
            :img-height="computedSizeImg"
            />
            </div>
          </slide>
          <template #addons>
            <navigation />
          </template>
        </carousel>
        <img-icon
        v-if="!ItemSelected01.img.length"
        :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
        />
        <Carousel
        v-if="ItemSelected01.img.length"
        :items-to-show="7"
        v-model="currentSlide"
        ref="carousel"
        >
          <Slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
            <div class="cont-pag" @click="slideTo(key)">
              <img class="img-pagination" :src="img">
            </div>
          </Slide>
          <template #addons>
            <pagination paginateByItemsToShow="true"/>
          </template>
        </Carousel>
      </div>
      </div>
      <div class="block-right">
        <div class="name">
          {{ ItemSelected01.name }}
        </div>
        <div class="price">
          <div v-if="ItemSelected01.oferta > 0 && ItemSelected01.oferta < ItemSelected01.preco">R$ {{ ItemSelected01.oferta }}</div>
          <div :class="{ disablePrice: ItemSelected01.oferta > 0 && ItemSelected01.oferta < ItemSelected01.preco }">R$ {{ ItemSelected01.preco }}</div>
        </div>
        <div class="desc">
          {{ ItemSelected01.descricao }}
        </div>
        <prod-caracter/>
        <div class="btn">
          <btn-whats @click="sendMessageWhats(ItemSelected01)"/>
        </div>
        <btn-like :data="ItemSelected01"/>
      </div>
    </div>
    <enb-suggestion/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel'
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css'
import BtnWhats from './BtnWhats'
import ProdCaracter from './ProdCaracter'
import EnbSuggestion from './EnbSuggestion'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import BtnLike from '@/components/Theme01/Like/BtnLike'
import api from '@/mixins/api'
import meta, { produtoMeta } from '@/mixins/meta'
export default {
  name: 'ProdutoView',
  components: { VueImageZoomer, Carousel, Slide, Pagination, Navigation, BtnWhats, ProdCaracter, EnbSuggestion, ImgIcon, BtnLike },
  computed: {
    ...mapGetters(['ItemSelected01', 'Empresa', 'Prefes']),
    computedSizeImg () {
      return window.innerWidth < 500 ? 300 : 300
    },
    metaPage () {
      let p = this.ItemSelected01
      let link = this.$route.params.link
      if(!p || !p.name || (link && p.link !== link)) return null
      return produtoMeta(this.Empresa, p)
    }
  },
  mixins: [api, meta],
  data () {
    return {
      currentSlide: 0,
      qtda: 1
    }
  },
  methods: {
    ...mapActions(['sendMessageWhats', 'GetProductId', '_UpdateProductVisualization']),
    slideTo(val) {
      this.currentSlide = val
    }
  },
  async beforeMount () {
    if(typeof this.$route.params.link !== 'undefined') {
      await this.GetProductId(this.$route.params.link)
    }
  },
  mounted () {
    if(this.Empresa.modelo === 'Modelo 03') {
      if(this.Prefes.componentModel03Nave) {
        if(this.Prefes.componentModel03Nave.name === 'EnbNave0302') {
          // document.getElementById('content').scrollIntoView({ 
          //   behavior: "smooth",
          //   block: "start"
          // })
        }
      }
    }
  },
  created () {
    this._UpdateProductVisualization(this.ItemSelected01.id)
  }
}
</script>

<style scoped>
.ProdutoView {
  width: 100%;
}

.cont-item {
  width: 70%;
  display: flex;
  margin: auto;
}

.cont-img {
  width: 300px;
  height: 300px;
  border: thin solid #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
}

.c-img {
  width: 295px;
  height: 295px;
  border-radius: 8px;
  overflow: hidden;
}

.cont-icon-img {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-left {
  width: 40%;
  padding-top: 2%;
}

.block-right {
  width: 40%;
  padding: 2%;
}

.cont-nav {
  width: 50%;
  margin: auto;
}

.cont-pag {
  width: 50px;
  height: 50px;
  margin: 5px;
  border: thin solid #CCCCCC;
}

.img-pagination {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.name {
  font-size: 20px;
  color: orange;
  text-align: left;
}

.price {
  display: flex;
  font-size: 20px;
  text-align: left;
  padding-top: 2%;
}

.disablePrice {
  text-decoration: line-through;
  color: #CCCCCC;
  padding-right: 2%;
}

.desc {
  white-space: pre-line;
  font-size: 16px;
  text-align: left;
  padding-top: 2%;
}

.btn {
  display: flex;
  justify-content: left;
  padding-top: 3%;
}

:deep(.carousel__prev) {
  left: -35px; /* Posiciona mais à esquerda */
  top: 50%;
  transform: translateY(-50%);
}

:deep(.carousel__next) {
  right: -35px; /* Posiciona mais à direita */
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 500px) {
  .cont-item {
    display: block;
    width: 90%;
  }
  .block-left {
    width: 100%;
  }
  .block-right {
    width: 100%;
  }
  .name {
    text-align: center;
  }
  .desc {
    text-align: justify;
  }
  .price {
    width: 100%;
    justify-content: center;
  }
  .btn {
    justify-content: center;
  }
}
</style>
